import { render, staticRenderFns } from "./BlockUserV2.vue?vue&type=template&id=4fcfce20"
import script from "./BlockUserV2.vue?vue&type=script&lang=js"
export * from "./BlockUserV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports